import defaultReducer from './redux/reducer';


export default {
	reducers: {
		dialog: defaultReducer,
	},
};